import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import { selectCurrentUser } from '../features/auth/authSlice'

const ProtectedRoute = () => {
  const user = useSelector(selectCurrentUser)
  if (!user) {
    return <Navigate to="/" replace />
  }
  if (user?.UserData?.user?.details?.onboarding_process !== 100) {
    return <Navigate to="/profile" replace />;
  }
  return <Outlet />
}

export default ProtectedRoute